(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-your-formula"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.fyf) return;
    var dialog = root.querySelector('[data-fyf-dialog]');
    var questions = Array.prototype.slice.call(root.querySelectorAll('[data-fyf-question]'));
    var results = Array.prototype.slice.call(root.querySelectorAll('[data-fyf-result]'));
    var intro = root.querySelector('[data-fyf-intro]');
    var flow = root.querySelector('[data-fyf-flow]');
    var progress = root.querySelector('[data-fyf-progress]');
    var progressBar = root.querySelector('[data-fyf-progress-bar]');
    var nav = root.querySelector('[data-fyf-nav]');
    var backBtn = root.querySelector('[data-fyf-back]');
    var nextBtn = root.querySelector('[data-fyf-next]');
    var after = root.querySelector('[data-fyf-after]');
    var tags = root.querySelector('[data-fyf-tags]');
    var template = root.getAttribute('data-progress-template') || '{n} / {total}';
    var nextLabel = nextBtn ? nextBtn.textContent : '';
    var finishLabel = root.getAttribute('data-finish-label') || nextLabel;
    var storageKey = 'fyf:' + (root.getAttribute('data-section-id') || 'quiz');
    var index = -1;
    var timer = null;
    var lastFocused = null;

    function show(el, on) { if (el) on ? el.removeAttribute('hidden') : el.setAttribute('hidden', ''); }
    function selected(q) { return q.querySelector('[data-fyf-answer][aria-pressed="true"]'); }
    function clearActive() {
      questions.forEach(function (q) { q.classList.remove('is-active'); });
      results.forEach(function (r) { r.classList.remove('is-active'); });
    }
    function showIntro() {
      clearTimeout(timer); index = -1; root.setAttribute('data-fyf-state','intro');
      show(intro,true); show(flow,false); show(after,false);
    }
    function showQuestion(i) {
      if (!questions.length) return;
      clearTimeout(timer); i=Math.max(0,Math.min(i,questions.length-1)); index=i;
      root.setAttribute('data-fyf-state','question'); show(intro,false); show(flow,true); show(after,false);
      show(progress,true); show(nav,true); clearActive(); questions[i].classList.add('is-active');
      if (progress) progress.textContent=template.replace('{n}',i+1).replace('{total}',questions.length);
      if (progressBar) progressBar.style.width=((i+1)/questions.length*100)+'%';
      if (nextBtn) { nextBtn.disabled=!selected(questions[i]); nextBtn.textContent=i===questions.length-1?finishLabel:nextLabel; }
      var focusTarget=questions[i].querySelector('[data-fyf-focus]'); if(focusTarget){focusTarget.setAttribute('tabindex','-1');focusTarget.focus({preventScroll:true});}
    }
    function preference(kind, fallback) {
      var q=questions.filter(function(q){return q.getAttribute('data-fyf-kind')===kind;})[0];
      var a=q&&selected(q);return a?(a.getAttribute('data-value')||fallback):fallback;
    }
    function score() {
      // The customer chooses the main priority explicitly. Collection order and
      // unrelated preference answers must never change that choice.
      var goal=preference('goal','everyday');
      return results.filter(function(r){return r.getAttribute('data-pillar')===goal;})[0]||null;
    }
    function eligibleProduct(data,diet,format,allergy) {
      if(allergy!=='none')return false;
      if((diet==='vegan'||diet==='vegetarian')&&data.diet!=='vegan')return false;
      return format==='any'||data.format===format;
    }
    function showResult(r) {
      if(!r)return;clearTimeout(timer);root.setAttribute('data-fyf-state','result');show(intro,false);show(flow,true);show(after,true);show(progress,false);show(nav,false);clearActive();r.classList.add('is-active');
      var diet=preference('diet','any'),format=preference('format','any'),allergy=preference('allergy','check');
      var limit=preference('routine','single')==='compare'?2:1,shown=0;
      r.querySelectorAll('[data-fyf-product]').forEach(function(card){
        var match=eligibleProduct({diet:card.getAttribute('data-fyf-diet'),format:card.getAttribute('data-fyf-format')},diet,format,allergy);
        var on=match&&shown<limit;show(card,on);if(on)shown++;
      });
      var fit=r.querySelector('[data-fyf-fit]'),notice=r.querySelector('[data-fyf-notice]');
      if(fit)fit.textContent=shown?(shown===1?'One option to consider. Check its ingredients and directions before choosing.':'Two options to compare. Choose the one that fits your routine; you do not need to take both.') : '';
      show(fit,shown>0);
      if(notice)notice.textContent=allergy!=='none'?'An allergy or intolerance needs a current label check, including any may-contain advice. This quiz will not automatically recommend a product for you. Explore the ingredients guide or contact us to check a formula.':'We do not have an available option that matches both your preferred format and diet for this priority. Try another format or explore the ingredients guide.';
      show(notice,shown===0);
      var pillar=r.getAttribute('data-pillar');if(tags)tags.value='newsletter, quiz-'+pillar;
      r.setAttribute('tabindex','-1');r.focus({preventScroll:true});
    }
    function next(){clearTimeout(timer);if(index<0||!selected(questions[index]))return;if(index<questions.length-1)showQuestion(index+1);else if(questions.every(function(q){return !!selected(q);}))showResult(score());}
    function back(){clearTimeout(timer);if(index>0)showQuestion(index-1);else showIntro();}
    function restart(){root.querySelectorAll('[data-fyf-answer]').forEach(function(b){b.setAttribute('aria-pressed','false');});showQuestion(0);}
    function openDialog() {
      if(!dialog)return;
      if(!questions.length && root.getAttribute('data-fyf-global')==='true'){ window.location.href='/pages/find-your-formula?open=1'; return; }
      lastFocused=document.activeElement;
      if(typeof dialog.showModal==='function'){ try { dialog.showModal(); } catch(e){ dialog.setAttribute('open',''); } } else { dialog.setAttribute('open',''); }
      showIntro();
      requestAnimationFrame(function(){var start=root.querySelector('[data-fyf-modal-start]'); if(start)start.focus({preventScroll:true});});
    }
    function closeDialog() {
      clearTimeout(timer); if(!dialog)return;
      if(dialog.open && typeof dialog.close==='function'){ try { dialog.close(); } catch(e){ dialog.removeAttribute('open'); } } else { dialog.removeAttribute('open'); }
      if(lastFocused && typeof lastFocused.focus==='function')lastFocused.focus({preventScroll:true});
    }

    root.addEventListener('click',function(e){
      var t=e.target;
      var answer=t.closest('[data-fyf-answer]');
      if(answer&&root.contains(answer)){var q=answer.closest('[data-fyf-question]');q.querySelectorAll('[data-fyf-answer]').forEach(function(b){b.setAttribute('aria-pressed','false');});answer.setAttribute('aria-pressed','true');if(nextBtn)nextBtn.disabled=false;clearTimeout(timer);timer=setTimeout(next,280);return;}
      if(t.closest('[data-fyf-modal-start]')){showQuestion(0);return;}
      if(t.closest('[data-fyf-start]')){openDialog();return;}
      if(t.closest('[data-fyf-close]')){closeDialog();return;}
      if(t.closest('[data-fyf-next]')){next();return;}
      if(t.closest('[data-fyf-back]')){back();return;}
      if(t.closest('[data-fyf-retake]')){restart();return;}
    });
    var startTrigger=root.querySelector('[data-fyf-start]');
    var modalStart=root.querySelector('[data-fyf-modal-start]');
    var closeTriggers=root.querySelectorAll('[data-fyf-close]');
    if(startTrigger) startTrigger.addEventListener('click',function(e){e.preventDefault();openDialog();});
    if(modalStart) modalStart.addEventListener('click',function(e){e.preventDefault();showQuestion(0);});
    Array.prototype.forEach.call(closeTriggers,function(btn){btn.addEventListener('click',function(e){e.preventDefault();closeDialog();});});
    if(dialog)dialog.addEventListener('cancel',function(e){e.preventDefault();closeDialog();});
    if(dialog)dialog.addEventListener('close',function(){showIntro();});

    root.fyf={showIntro:showIntro,showQuestion:showQuestion,showResult:showResult,questions:questions,results:results,open:openDialog,close:closeDialog};
    root.classList.add('is-ready');
    showIntro();
    if(root.getAttribute('data-fyf-global')==='false' && /[?&]open=1(?:&|$)/.test(window.location.search)){ setTimeout(openDialog,0); }
  }
  function initAll(scope){Array.prototype.forEach.call((scope||document).querySelectorAll('[data-fyf]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll();});else initAll();
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
  document.addEventListener('shopify:block:select',function(e){var el=e.target,root=el.closest('[data-fyf]');if(!root||!root.fyf)return;var q=el.closest('[data-fyf-question]');if(q){root.fyf.open();root.fyf.showQuestion(root.fyf.questions.indexOf(q));return;}var r=el.closest('[data-fyf-result]');if(r){root.fyf.open();root.fyf.showResult(r);}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inside-the-formula"] && !Shopify.designMode) return;
  try {
    
  function initializeFormula(root) {
    if (root.dataset.formulaReady === 'true') return;
    root.dataset.formulaReady = 'true';
    const track = root.querySelector('[data-formula-track]');
    let opener;
    let savedBodyStyle;
    let savedScrollY;
    const unlock = () => {
      if (savedBodyStyle === undefined) return;
      document.body.style.cssText = savedBodyStyle;
      document.documentElement.classList.remove('formula-modal-open');
      window.scrollTo(0, savedScrollY);
      savedBodyStyle = undefined;
      opener?.focus({ preventScroll: true });
    };
    root.querySelectorAll('[data-formula-open]').forEach(card => {
      const open = () => {
        const dialog = root.querySelector('[id="' + card.dataset.formulaOpen + '"]');
        if (!dialog || dialog.open) return;
        opener = card;
        savedScrollY = window.scrollY;
        savedBodyStyle = document.body.style.cssText;
        dialog.querySelectorAll('template[data-formula-image]').forEach(template => {
          template.replaceWith(template.content.cloneNode(true));
        });
        dialog.showModal();
        document.documentElement.classList.add('formula-modal-open');
        Object.assign(document.body.style, { position: 'fixed', top: -savedScrollY + 'px', width: '100%' });
        dialog.scrollTop = 0;
        dialog.querySelector('[data-formula-close]')?.focus({ preventScroll: true });
      };
      card.addEventListener('click', open);
      card.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open();
        }
      });
    });

    const openSharedFormula = () => {
      let anchor;
      try { anchor = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      if (!anchor.startsWith('formula-drawer-')) return;
      const card = [...root.querySelectorAll('[data-formula-open]')].find(item => item.dataset.formulaOpen === anchor);
      card?.click();
    };
    window.addEventListener('hashchange', openSharedFormula);
    openSharedFormula();
    root.querySelectorAll('dialog.formula-section__drawer').forEach(dialog => {
      dialog.querySelector('[data-formula-close]')?.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        dialog.close();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', unlock);
    });
    root.querySelectorAll('.formula-section__nav-btn').forEach(button => {
      button.addEventListener('click', () => {
        const card = track?.querySelector('.formula-section__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: (card.getBoundingClientRect().width + gap) * (button.dataset.direction === 'next' ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) {
        root.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        unlock();
      }
    });
  }
  document.querySelectorAll('.formula-section').forEach(initializeFormula);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.formula-section').forEach(initializeFormula));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vechen-welcome-offer"]) return;
  try {
    
if (!customElements.get('vechen-welcome-offer')) {
  customElements.define('vechen-welcome-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.initFrame) return;
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = 0;
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      if (this.ready) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.ready = true;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.params = new URLSearchParams(location.search);
      this.preview = this.params.get('vechen_offer') === 'preview' || (window.Shopify?.designMode && this.dataset.editorPreview === 'true');
      this.existingBuyer = this.dataset.existingBuyer === 'true';
      this.engaged = window.scrollY > 80;
      this.shown = false;
      const priorViews = Number(this.read('sessionStorage', 'vechen-welcome-views') || 0);
      this.write('sessionStorage', 'vechen-welcome-views', String(priorViews + 1));
      this.engaged = this.engaged || priorViews > 0;
      this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), opts));
      this.dialog.addEventListener('close', () => this.finishClose(), opts);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, opts);
      this.querySelector('[data-welcome-copy]')?.addEventListener('click', async () => {
        const code = this.querySelector('[data-welcome-code]');
        const status = this.querySelector('[data-welcome-copy-status]');
        try {
          await navigator.clipboard.writeText(code.textContent.trim());
          status.textContent = 'Code copied.';
        } catch {
          const range = document.createRange();
          range.selectNodeContents(code);
          const selection = window.getSelection();
          selection?.removeAllRanges(); selection?.addRange(range);
          status.textContent = 'Select and copy the code above.';
        }
      }, opts);
      const form = this.querySelector('form');
      form?.addEventListener('submit', () => {
        this.write('sessionStorage', 'vechen-welcome-pending', String(Date.now()));
        const redirect = form.querySelector('input[name="return_to"]');
        if (redirect) {
          const url = new URL(redirect.value, location.origin);
          const previewId = this.params.get('preview_theme_id');
          if (previewId && /^\d+$/.test(previewId)) url.searchParams.set('preview_theme_id', previewId);
          redirect.value = url.pathname + url.search;
        }
        // Native submission is intentional: Shopify validates the signup and handles its spam challenge.
      }, opts);
      const nativeSuccess = !!this.querySelector('[data-welcome-native-success]');
      const errors = !!this.querySelector('[data-welcome-errors]');
      const pending = Number(this.read('sessionStorage', 'vechen-welcome-pending') || 0);
      const returned = this.params.has('vechen_welcome') || Date.now() - pending < 900000;
      this.claimed = Number(this.read('localStorage', 'vechen-welcome-claimed-until') || 0) > Date.now();
      if (!this.existingBuyer && (nativeSuccess || this.dataset.subscribed === 'true' || this.claimed)) this.showCode();
      if (nativeSuccess && returned) {
        this.write('localStorage', 'vechen-welcome-claimed-until', String(Date.now() + 180 * 86400000));
        this.write('sessionStorage', 'vechen-welcome-pending', '0');
      }
      this.attachReopen();
      if (this.preview || (returned && (nativeSuccess || errors))) {
        this.timer = setTimeout(() => this.open(true), 150);
      } else if (this.dataset.auto === 'true' && !this.claimed && !window.Shopify?.designMode) {
        this.started = Date.now();
        window.addEventListener('scroll', () => { if (window.scrollY > 80) this.engaged = true; }, { ...opts, passive: true });
        this.timer = setTimeout(() => this.maybeOpen(), Math.max(5, Number(this.dataset.delay) || 12) * 1000);
      }
    }
    read(storage, key) { try { return window[storage].getItem(key); } catch { return null; } }
    write(storage, key, value) { try { window[storage].setItem(key, value); } catch { /* Private browsing must not break the form. */ } }
    showCode() {
      const signup = this.querySelector('[data-welcome-signup]');
      const success = this.querySelector('[data-welcome-success]');
      if (signup) { signup.hidden = true; signup.querySelectorAll('input,button').forEach(el => { el.disabled = true; }); }
      if (success) success.hidden = false;
    }
    attachReopen() {
      if (this.existingBuyer) return;
      const footer = document.querySelector('footer .email-signup-block');
      if (!footer || footer.querySelector('[data-welcome-reopen]')) return;
      this.reopen = document.createElement('button');
      this.reopen.type = 'button';
      this.reopen.className = 've-welcome-reopen';
      this.reopen.setAttribute('data-welcome-reopen', '');
      this.reopen.setAttribute('aria-haspopup', 'dialog');
      this.reopen.textContent = 'Get 10% off your first order';
      this.reopen.addEventListener('click', () => this.open(true), { signal: this.abort.signal });
      footer.append(this.reopen);
    }
    blocked() {
      return document.hidden || !!document.querySelector('dialog[open],theme-drawer[open],.menu-drawer-container[open]') || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
    }
    maybeOpen() {
      if (!this.isConnected || this.shown || this.existingBuyer) return;
      if (Number(this.read('localStorage', 'vechen-welcome-dismiss-until') || 0) > Date.now()) return;
      if (Number(this.read('localStorage', 'vechen-welcome-claimed-until') || 0) > Date.now()) return;
      if (!this.engaged || this.blocked()) {
        this.timer = setTimeout(() => this.maybeOpen(), 1500);
        return;
      }
      this.open(false);
    }
    open(manual) {
      if (this.dialog.open || (!manual && this.blocked())) return;
      if (document.querySelector('dialog[open],theme-drawer[open],.menu-drawer-container[open]')) return;
      this.focusBefore = document.activeElement;
      this.scrollBefore = window.scrollY;
      this.dialog.showModal();
      document.documentElement.style.setProperty('--ve-welcome-scroll-top', '-' + this.scrollBefore + 'px');
      document.documentElement.classList.add('ve-welcome-open');
      this.shown = true;
      this.querySelector('[data-welcome-close]')?.focus({ preventScroll: true });
    }
    unlock() {
      document.documentElement.classList.remove('ve-welcome-open');
      document.documentElement.style.removeProperty('--ve-welcome-scroll-top');
      const root = document.documentElement;
      const priorBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, this.scrollBefore || 0);
      root.style.scrollBehavior = priorBehavior;
    }
    finishClose() {
      this.unlock();
      if (!this.preview) this.write('localStorage', 'vechen-welcome-dismiss-until', String(Date.now() + Math.max(1, Number(this.dataset.dismissDays) || 7) * 86400000));
      if (this.focusBefore?.isConnected) this.focusBefore.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = 0;
      clearTimeout(this.timer);
      if (this.dialog?.open) { this.dialog.close(); this.unlock(); }
      this.abort?.abort();
      this.reopen?.remove();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
